import React, { useState } from 'react';
import { withStyles } from '@material-ui/styles';
import ImageCarousel from '../ImageCarousel';
import cloneDeep from 'lodash.clonedeep';
import { Dialog, DialogContent, Button as MuiButton } from '@material-ui/core';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';
import SelfInspectCameraIcon from './SelfInspectCameraIcon';
import SelfInspectInfoBox from './SelfInspectInfoBox';
import SelfInspectDivider from './SelfInspectDivider';
import SelfInspectButton from './SelfInspectButton';
import { getImageUri } from '../../helpers/images';
import { addLocalFileInfo, getImageFile, resizeImageFile } from './utils';

const styles = theme => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  scrollContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    overflow: 'inherit',
  },

  supportNumber: {
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  imagePreviewContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },

  actionContainer: {
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
  },
  image: {
    maxHeight: '80%',
    maxWidth: '100%',

    borderRadius: 5,
    padding: '20px 30px',
    background: '#00000022',
  },

  questionLabel: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 10,
  },

  questionLabel2: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  questionLabel3: {
    fontSize: '1rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  imageHeaderContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  answerContainerOuter: {
    width: '100%',
    flex: 1,
    fontSize: '1.25rem',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    marginTop: 10,
  },

  removeImageIcon: {
    color: 'var(--jmi-red)',
    fontSize: 30,
    marginLeft: 30,
  },
});

const IMAGE_UPLOAD_INPUT_ID = 'image-capture';

const BOTTOM_PANEL_TRANSITION = '0.5s all ease-in-out';

const getImageInputId = questionId => `${IMAGE_UPLOAD_INPUT_ID}_${questionId}`;

const TakePictureCard = withStyles(styles)(
  ({
    // form values
    cardNumber,
    questionId,
    questionImage,
    questionLabel,
    questionLabel2,
    questionLabel3,
    shortLabel,
    answerValue,
    hideDevButton,
    navLabelOverride,
    multiple,
    //
    // functions
    updateAnswer,
    resetAnswer,
    confirmAnswer,
    deleteImage,
    //
    // other
    isActive,
    isBefore,
    isAfter,
    classes,
    selfInspectIntro,
    stepIndex,
    pendingSaves,
    goBack,
    hideBackButton,
  }) => {
    const [imageToConfirmRemoval, setImageToConfirmRemoval] = useState(null);
    const [carouselContainerWidth, setCarouselContainerWidth] = useState(undefined);

    const hasAnswer = (answerValue?.length ?? 0) > 0;

    const imageInputId = getImageInputId(questionId);

    const onMediaAdded = async evt => {
      try {
        const { target } = evt;
        const files = Array.from(target.files);
        // const files = Array.from(document.getElementById(getImageInputId(questionId)).files);

        const wasCanceled = !files.length;

        if (wasCanceled) {
          return;
        }

        const media = await Promise.all(
          files.map(async (file, fileIndex) => {
            // const maxSizeBytes = 1000 /* bytes in kb */ * 1000; /* 1000 kb in mb */ // = 1MB
            const maxSize = 1920;

            let imageObject = addLocalFileInfo(file, fileIndex);
            imageObject = await getImageFile(imageObject);

            const needsResized = imageObject.width > maxSize || imageObject.height > maxSize;

            if (needsResized) {
              const resizedFile = await resizeImageFile(imageObject, { maxSize });
              imageObject = addLocalFileInfo(resizedFile, fileIndex);
              console.log('image', imageObject);
            }

            return imageObject;
          }),
        );

        const updatedImage = media[0];

        let answerCopy = cloneDeep(answerValue);

        if (answerCopy === null) {
          answerCopy = [updatedImage];
        } else {
          answerCopy.push(updatedImage);
        }

        const answerUpdate = {
          cardNumber,
          questionId,
          value: answerCopy, //multiple ? media : media[0],
        };

        updateAnswer(answerUpdate);

        // clear input so they could add the same image again if they accidentally removed it
        target.value = null;

        // add images to the rest of the images
        // put the images first in case anything changed with a duplicated image but it keeps the same filename
        // uploadPhotos(media);
      } catch (error) {
        console.log('error', error);
      }
    };

    const confirmRemoveImage = () => {
      removeImage(imageToConfirmRemoval);
      setImageToConfirmRemoval(null);
    };

    const cancelRemoveImage = () => {
      setImageToConfirmRemoval(null);
    };

    const removeImage = async image => {
      let answerCopy = cloneDeep(answerValue);

      if (image.formImageId) {
        deleteImage(image.formImageId);

        answerCopy = answerCopy.filter(av => av.formImageId != image.formImageId);
      } else {
        if (image.uploadInitiated) {
          if (image.error) {
          } else {
          }
        } else {
          answerCopy = answerCopy.filter(av => av.fileName != image.fileName);
        }
      }

      updateAnswer({
        cardNumber,
        questionId,
        value: answerCopy,
      });
    };

    const handleContinue = () => {
      confirmAnswer({
        cardNumber,
        questionId,
        answerValue,
      });
    };

    // isActive && console.log('carouselContainerWidth', carouselContainerWidth);

    return (
      <>
        <div className={classes.container}>
          <div className={classes.scrollContainer}>
            <div
              style={{
                maxHeight: hasAnswer ? 0 : '100vh',
                transition: BOTTOM_PANEL_TRANSITION,
                overflow: 'hidden',
              }}
            >
              {!!questionLabel && <SelfInspectInfoBox>{questionLabel}</SelfInspectInfoBox>}

              {!!questionLabel2 && (
                <SelfInspectQuestionLabel
                  style={{
                    marginTop: 20,
                    marginBottom: 10,
                  }}
                >
                  {questionLabel2}
                </SelfInspectQuestionLabel>
              )}
            </div>

            {!!questionId && (
              <>
                <div
                  className={classes.answerContainerOuter}
                  style={{
                    overflow: !!answerValue ? 'auto' : 'hidden',
                  }}
                  ref={ref => {
                    if (ref) {
                      setCarouselContainerWidth(ref.offsetWidth);
                    }
                  }}
                >
                  {!hasAnswer && (
                    <img
                      src={questionImage}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        margin: 'auto',
                        borderRadius: 10,
                      }}
                    />
                  )}

                  {isActive && (
                    <ImageCarousel
                      isQuickvue
                      debug
                      onClick={image => setImageToConfirmRemoval(image)}
                      width={carouselContainerWidth}
                      height="100%"
                      images={answerValue ? answerValue : []}
                      onDelete={(image, imageIndex) => {
                        setImageToConfirmRemoval(image);
                      }}
                      deleteIconPosition="over-image"
                      containerStyle={{
                        marginBottom: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                      }}
                      blobImageSizeFolder="output"
                    />
                  )}
                </div>

                <input
                  type="file"
                  accept="image/jpeg"
                  capture={selfInspectIntro.remote ? undefined : 'environment'}
                  id={imageInputId}
                  name={imageInputId}
                  className="hide"
                  onChange={onMediaAdded}
                />
              </>
            )}

            {!!questionLabel3 && (
              <div className={classes.supportNumber}>
                <div className={classes.questionLabel3}>{questionLabel3}</div>
              </div>
            )}
          </div>

          <SelfInspectDivider />

          <div className={classes.imagePreviewContainer}>
            <div className="flex-1">
              {hasAnswer && !!shortLabel && <SelfInspectQuestionLabel>{shortLabel}</SelfInspectQuestionLabel>}
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignSelf: 'stretch',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              <div
                className="text-center text-note"
                style={{
                  marginRight: 10,
                }}
              >
                Add Photo(s)
              </div>

              <SelfInspectCameraIcon imageInputId={imageInputId} />
            </div>
          </div>

          <SelfInspectDivider />

          <div className={classes.actionContainer}>
            {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="mr-20" />}

            <SelfInspectButton
              label={!questionId || (answerValue && answerValue.length > 0) ? 'Keep going!' : 'Picture please!'}
              onClick={handleContinue}
              disabled={!questionId || (answerValue && answerValue.length > 0) ? false : true}
              className="flex-1"
            />
          </div>

          <Dialog
            open={!!imageToConfirmRemoval}
            maxWidth="lg"
            onClose={cancelRemoveImage}
            aria-labelledby="image-modal-title"
            className={classes.imageModal}
            autoScrollBodyContent={false}
            contentStyle={{ width: '100%', maxWidth: 'none' }}
          >
            <DialogContent className="col-center-center">
              <h3 style={{ textAlign: 'center' }}>Please confirm that you want to remove this image</h3>
              <img
                style={{
                  width: 'auto',
                  maxWidth: '100%',
                  maxHeight: '50vh',
                  borderRadius: 5,
                }}
                {...imageToConfirmRemoval}
                src={
                  !!imageToConfirmRemoval
                    ? getImageUri(imageToConfirmRemoval, {
                        blobImageSizeFolder: 'output',
                      })
                    : null
                }
                alt="Missing"
              />
              <div
                className="row-center-center"
                style={{
                  marginTop: 25,
                  marginBottom: 5,
                }}
              >
                <MuiButton className="red-button" style={{ marginRight: 10 }} onClick={confirmRemoveImage}>
                  Confirm Removal
                </MuiButton>

                <MuiButton className="blue-button" style={{ marginLeft: 10 }} onClick={cancelRemoveImage}>
                  Close
                </MuiButton>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  },
);

TakePictureCard.propTypes = {};

TakePictureCard.defaultProps = {};

export default TakePictureCard;
